module.exports = __webpack_public_path__ + "h5/img/collection-receive-bg.38491c3d.png";